export const STICKY_SECTION_HEIGHT = 356;
export const STICKY_SECTION_DEPENDENCIES_HEIGHT = 300;
